export default "__VITE_ASSET__r87MgWQ$__"